import "/tmp/tmp-8023-8muGggC0250G/1947338146ce/index.module.css";
export default {"container":"index-module__container___fTvZI","content":"index-module__content___HAHyF","contentBack":"index-module__contentBack___teSNT"};